import React, { useEffect, useState } from 'react';
import {
    Box, CssBaseline, CircularProgress, Grid, Typography, Button,
    FormControlLabel, FormGroup, Checkbox, Tooltip, TextareaAutosize,
    RadioGroup, Radio, TextField
  } from '@material-ui/core';
import { useStyles } from './styles';
import CustomBreadcrum from '../Breadcrum';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import playIcon from '../../assets/playIcon.png';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';

import Completed from '../../assets/RequestDocument/Completed.svg';
import InProgress from '../../assets/RequestDocument/InProgress.svg';
import Pending2 from '../../assets/RequestDocument/Pending2.svg';
import Pending3 from '../../assets/RequestDocument/Pending3.svg';
import SubmittedYellow from '../../assets/RequestDocument/SubmittedYellow.svg';
import fileReplace from '../../assets/fileReplace.png';
import image from '../../assets/image.png';
import pdf from '../../assets/pdf.png';
import InfoIcon from '@material-ui/icons/Info';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import { styled } from '@material-ui/core/styles';
import { getLmaDetails, submitLmaDetails, deleteDocument, downloadLmaDocument, uploadSupportedDocs, downloadSupportedLmaDocument, deleteSupportedDocument, getSpocDetails } from '../../actions';
import { renderDefaultMsg, getAppSource, getUserType, scrollTop, checkDigitOnly } from '../../helpers';
import { decrypt, encrypt } from '../../helpers/encrypt';
import { DeleteConfirmation } from './DeleteConfirmation';
import { LMA_FILE_SIZE_LIMIT } from '../../helpers/constants';
import { FileSizeAlert } from './FileSizeAlert';
import { HowItWorks } from './../Lma/HowItWorks';
import { LmaValidate } from './LmaValidate';
import Cookies from 'js-cookie';

import {
  MuiPickersUtilsProvider, KeyboardDatePicker
} from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import moment from 'moment';
import './index.css';

const LightTooltip = withStyles((theme) => ({
  arrow: {
    color: '#235A86'
  },
  tooltip: {
    backgroundColor: '#235A86',
    color: '#fffff',
    fontFamily: "Montserrat",
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    padding: "16px",
    fontSize: 14,
    maxWidth: 400,
    fontWeight: 500,
    borderRadius: 8
  },
}))(Tooltip);

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const LmaDetails = (props) => {

  const classes = useStyles();
  const history = useHistory();
  const loanInfoData = useSelector(state => state?.loanInfoReducer);

  const [activeStep, setActiveStep] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setErrorMessage] = useState();
  const [lmaSupportDocuments, setLmaSupportDocuments] = useState([]);
  const [tooltipMsg, setTooltipMsg] = useState(`<p style='font-size: 14px'>If you select yes "Planning to Sell Property," please provide the following additional documents:
  </br>
  <ul>
    <li>Listing Agreement</li>
    <li> Realtor Information</li>
    <li>Purchase Offer (Optional)</li>
  </ul>
  </p>`);

  const [hardshipDetails, setHardshipDetails] = useState({
    hardshipDate: 1,
    hardshipDuration: "",
    hardshipLocalFileName: "",
    hardshipS3Path: "",
    hardshipSummary: "",
    isSellProperty: false,
    jiraID: '',
    listingDocumentS3Path: '',
    listingLocalName: '',
    lmaApplicationId: '',
    lmaStatus: '',
    packageS3Path: '',
    purchaseLocalFileName: '',
    purchaseOfferS3S3Path: '',
    retalorEmailId: '',
    retalorName: '',
    retalorPhone: '',
    comments: ''
  });
  const [loading, setLoader] = useState(false);
  const [deleteStatus, setDeletePopup] = useState(false);
  const [uploadDocCategoryIndex, setCategoryIndex] = useState(null);
  const [errMsg, setErrorMsg] = useState('');
  const [validationErrMsg, setValidationErrorMsg] = useState(null);
  const [mobileValidationErrorMsg, setMobileValidationErrorMsg] = useState('');
  const [alertStatus, setAlertStatus] = useState(false);
  const [file, setFilesName] = useState('');
  const [howItWorksPopupStatus, setHowItWorksPopupStatus] = useState(false);
  const [validateLma, setValidateLma] = useState(false);
  const [docValidations, setDocValidations] = useState([]);
  const [realtorInfoErr, setRealtorInfoErr] = useState(false);
  const [listingDocReq, setListingDocReqErr] = useState(false);
  const [realtorNameInfoErr, setRealtorNameErr] = useState(false);
  const [sellPropertAcc, setSellPropertyAcc] = useState(false);
  const [hardshipSummaryErr, setHardshipSummaryErr] = useState(false);
  const [hardshipDateErr, setHardshipDateErr] = useState(false);

  const steps = [
    {
      label: 'Hardship Details & Loss Mitigation Form'
    },
    {
      label: 'Upload Supporting Documents'
    }
  ];
  
  useEffect(() => {
    if (props.accountNumber) {
      getLmaDetail(props, false)
      getSpocDetail(props)
    }
  }, [props])

  const handleHowItWorksClose = () => {
    setHowItWorksPopupStatus(false)
  }
  
  const downloadDocument = async (type, name) => {
    const data = {
      "accountNumber": props.accountNumber,
      "lmaApplicationId": hardshipDetails.lmaApplicationId,
      "documentType": type,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await downloadLmaDocument(data)
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    } else {
      setErrorMsg(renderDefaultMsg('400'))
    }
  }
 
  const deleteDoc = async (type) => {
    const data = {
      "accountNumber": props.accountNumber,
      "lmaApplicationId" : hardshipDetails.lmaApplicationId,
      "documentType": type,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await deleteDocument(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode === '0' || res?.responseData?.lstResponseStatus[0]?.statusCode === 0) {
      setErrorMessage()
      if (type == "LMA") {
        setHardshipDetails({ ...hardshipDetails, ['hardshipLocalFileName']: "", ['hardshipS3Path']: "" });
      } else if (type == "Purchase") {
        setHardshipDetails({ ...hardshipDetails, ['purchaseLocalFileName']: "", ['purchaseOfferS3S3Path']: ""  });
      } else {
        setHardshipDetails({ ...hardshipDetails, ['listingDocumentS3Path']: "", ['listingLocalName']: ""  });
      }
    } else {
      setErrorMessage(res?.responseData?.lstResponseStatus[0]?.StatusDesc)
    }
  }

  const downloadSupportedDocs = async (name, id) => {
    const data = {
      "accountNumber": props.accountNumber,
      "id": id,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };
    const response = await downloadSupportedLmaDocument(data)
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    } else {
      setErrorMsg(renderDefaultMsg('400'))
    }
  }

  const deleteSupportedDocs = async (id, categoryIndex, subCategoryIndex , docIndex) => {
    const data = {
      "accountNumber": props.accountNumber,
      "id": id,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await deleteSupportedDocument(data);
    if ((res?.responseData?.lstResponseStatus[0]?.statusCode === '0') || (res?.responseData?.lstResponseStatus[0]?.statusCode === 0)) {
      setErrorMessage()
      const documents = [...lmaSupportDocuments];
      if (documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"].length > 1) {
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"].splice(docIndex,1);
        setLmaSupportDocuments(documents)
      } else {
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"][0]["accountNumber"] = null
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"][0]["comments"] = null
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"][0]["createdDate"] = null
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"][0]["localFileName"] = null
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"][0]["masterSupportDocId"] = 0
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"][0]["uploadDocumentId"] = 0
        documents[categoryIndex]["subCategory"][subCategoryIndex]["uploadedDocs"][0]["uploadSupportDocPath"] = null
        setLmaSupportDocuments(documents)
      }
  
    } else {
      setErrorMessage(res?.responseData?.lstResponseStatus[0]?.StatusDesc)
    }
  }

  const getLmaDetail = async (props, status) => {
    // setLoader(true)
    const data = {
      "accountNumber": props.accountNumber,
      "lmaApplicationId" : 0,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getLmaDetails(data);
    if ((res?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
      const hardshipDetails = res?.responseData?.responseData.hardshipDetails;
      setLoader(false)
      setErrorMessage()
      const comment = res?.responseData?.responseData.lmaSupportDocuments[1].subCategory.filter((subCat) => subCat.supportDocName.toLowerCase() == "other income")
      setHardshipDetails({
        hardshipDate: hardshipDetails.dateHardshipStarted,
        hardshipDuration: hardshipDetails.hardshipDuration,
        hardshipLocalFileName: hardshipDetails.lmaFormLocalName,
        hardshipS3Path: hardshipDetails.lmaFormPath,
        hardshipSummary: hardshipDetails.hardshipSummary,
        isSellProperty: hardshipDetails.isSellProperty ? "Yes" : "No",
        jiraID: hardshipDetails.jiraId,
        listingDocumentS3Path: hardshipDetails.listingDocumentPath,
        listingLocalName: hardshipDetails.listingLocalName,
        lmaApplicationId: hardshipDetails.lmaApplicationId,
        lmaStatus: hardshipDetails.lmaStatus,
        packageS3Path: hardshipDetails.packageS3Path,
        purchaseLocalFileName: hardshipDetails.purchaseOfferLocalName,
        purchaseOfferS3S3Path: hardshipDetails.purchaseOfferPath,
        retalorEmailId: hardshipDetails.retalorEmailId !== null ? decrypt(hardshipDetails.retalorEmailId) : hardshipDetails.retalorEmailId,
        retalorName:  hardshipDetails.retalorName,
        retalorPhone: hardshipDetails.retalorPhone !== null ? decrypt(hardshipDetails.retalorPhone) : hardshipDetails.retalorPhone,
        comments: comment[0]?.uploadedDocs[0]?.comments !== null ? comment[0]?.uploadedDocs[0]?.comments : ''
      });
     
      if (status) {
          setActiveStep(1)
          let newObj = [...res?.responseData?.responseData.lmaSupportDocuments]  
          newObj[0]['status'] = true
          const docs = newObj.map((cat, index) => ({ ...cat, 'subCategory': cat.subCategory.map((subcat, ind) => ({ ...subcat, 'checked' : ((subcat.supportDocCode == 'PID') || (subcat.supportDocCode == 'UtilityBill')) ? true : lmaSupportDocuments[index]['subCategory'][ind]['checked'] })) }))
          setLmaSupportDocuments(docs)
      } else if (uploadDocCategoryIndex !== null) {
        let newObj = [...res?.responseData?.responseData.lmaSupportDocuments]  
        newObj[uploadDocCategoryIndex]['status'] = true
        const docs = newObj.map((cat, index) => ({ ...cat, 'subCategory': cat.subCategory.map((subcat, ind) => ({ ...subcat, 'checked' : ((subcat.supportDocCode == 'PID') || (subcat.supportDocCode == 'UtilityBill')) ? true : lmaSupportDocuments[index]['subCategory'][ind]['checked'] })) }))
          setLmaSupportDocuments(docs)
       } else {
       if (lmaSupportDocuments.length > 0) {
        let newObj = [...res?.responseData?.responseData.lmaSupportDocuments]  
        const docs = newObj.map((cat, index) => ({ ...cat, 'subCategory': cat.subCategory.map((subcat, ind) => ({ ...subcat, 'checked' : ((subcat.supportDocCode == 'PID') || (subcat.supportDocCode == 'UtilityBill')) ? true : lmaSupportDocuments[index]['subCategory'][ind]['checked'] })) }))
        setLmaSupportDocuments(docs)
       } else {
        let newObj = [...res?.responseData?.responseData.lmaSupportDocuments]
        const docs = newObj.map((cat, index) => ({ ...cat, 'subCategory': cat.subCategory.map((subcat, ind) => ({ ...subcat, 'checked' : ((subcat.supportDocCode == 'PID') || (subcat.supportDocCode == 'UtilityBill')) ? true : false })) }))
        setLmaSupportDocuments(docs);
       }
       }
    } else {
      setLoader(false)
      setLmaSupportDocuments([]);
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const getSpocDetail = async (props) => {
    const data = {
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getSpocDetails(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      getLMAStatus(res?.responseData?.responseData.lmaStatus)
    } 
  }

  const getLMAStatus = (lmaStatus) => {
    if ((lmaStatus.toLowerCase() == "spoc") || (lmaStatus.toLowerCase() == 'lma not allowed')) {
      history.push('/FinancialHardship')
    } else if ((lmaStatus.toLowerCase() !== "in progress") && (lmaStatus.toLowerCase() !== "blank")) {
      history.push('/LmaStatus')
    }  
  }

  const dateFormat = (selectedDate) => {
    if (selectedDate) {
      let dt = new Date(selectedDate)
      return `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}`
    } else {
      return ''
    }
  }

  const submitLmaDetail = async (files, type, status) => {
   
    setLoader(true)
    const formData = new FormData();
    formData.append('lmaApplicationId', hardshipDetails.lmaApplicationId);
    formData.append('dateHardshipStarted', hardshipDetails.hardshipDate ? dateFormat(hardshipDetails.hardshipDate) : null);
    formData.append('hardshipDuration', hardshipDetails.hardshipDuration);
    formData.append('hardshipSummary',  hardshipDetails.hardshipSummary == null ? '' : hardshipDetails.hardshipSummary);
    formData.append('isSellProperty', (hardshipDetails.isSellProperty == "Yes") ? true : false);
    formData.append('retalorEmailId',  encrypt(hardshipDetails.retalorEmailId));
    formData.append('retalorName', hardshipDetails.retalorName);
    formData.append('retalorPhone',  encrypt(hardshipDetails.retalorPhone));
    formData.append('lmaFile', type == "LMA" ? files : null);
    formData.append('listingFile', type == "Sale" ? files : null);
    formData.append('purchaseFile', type == "Purchase" ? files : null);
    formData.append('documentType', (files !== null) ? type : "");
    formData.append('privateLabelUrl', Cookies.get("privateLabelUrl"));
    formData.append('browser', Cookies.get("browser"));
    formData.append('appSource', getAppSource());
    formData.append('userType', getUserType());
    formData.append('ipAddress', Cookies.get('publicIp'));
    formData.append('accountNumber', props.accountNumber);
    formData.append('userName', "");
    const res = await submitLmaDetails(formData);
    if ((res?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
      setLoader(false)
      setErrorMessage()
      getLmaDetail(props, status)
    } else {
      setLoader(false)
      setErrorMessage(res?.responseData?.lstResponseStatus[0]?.StatusDesc)
      setLmaSupportDocuments([]);
    } 
  }

  const uploadFile = (event, status) => {
    event.persist();
    uploadSupportedDoc(event.target.files[0], status)
  }

  const uploadSupportedDoc = async (files, status) => {
    setLoader(true)
    const formData = new FormData();
    formData.append('uploadDocumentId', 0);
    formData.append('masterSupportDocId',  status.masterSupportDocId);
    formData.append('supportDocumentFile', files);
    formData.append('supportDocCode', status.uploadedDocs[0].accountNumber == null ? `${status.supportDocCode}` + "_1" : `${status.supportDocCode}` + "_" + (status.uploadedDocs.length + 1));
    formData.append('comments', (status.supportDocName.toLowerCase() == "other income") ? hardshipDetails.comments : null);  
    formData.append('privateLabelUrl', Cookies.get("privateLabelUrl"));
    formData.append('browser', Cookies.get("browser"));
    formData.append('appSource', getAppSource());
    formData.append('userType', getUserType());
    formData.append('ipAddress', Cookies.get('publicIp'));
    formData.append('accountNumber', props.accountNumber);
    formData.append('userName', "");

    const res = await uploadSupportedDocs(formData);
    if ((res?.responseData?.lstResponseStatus[0]?.statusCode === '0') || (res?.responseData?.lstResponseStatus[0]?.statusCode === 0)) {
      setLoader(false)
      setErrorMessage()
      getLmaDetail(props, false)
    } else {
      setLoader(false)
      setErrorMessage(res?.responseData?.lstResponseStatus[0]?.StatusDesc)
      setLmaSupportDocuments([]);
    } 
  }

  const routeToFinancialHardship = () => {
    history.push('/Lma')
  }

  const calculateCommentLenth = () => {
    const length = hardshipDetails.hardshipSummary?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }
 
  const handleDateChange = async (date) => {
    setHardshipDetails({ ...hardshipDetails, ['hardshipDate']: date });
    setIsOpen(false)
  }
 
  const handleHardshipTerm = (value, event) => {
    setHardshipDetails({ ...hardshipDetails, ['hardshipDuration']: event?.target?.checked ? value : null });
  }

  const handleUploadDocCheckbox = (event, catIndex, subCatIndex) => {
    event.persist()
    let newObj = [...lmaSupportDocuments]  
    newObj[catIndex]['subCategory'][subCatIndex]['checked'] = event.target.checked
    setLmaSupportDocuments(newObj)
  }
 
  console.log(lmaSupportDocuments)
  const shortText = (text) => {
    if ((text !== '') && (text !== null)) {
      return text?.length < 20 ? text : text?.substr(0, 20) + '...'
    } else {
      return text
    }
  }  

  const handleChange = (event) => {
    setHardshipDetails({ ...hardshipDetails, [event.target.name]: event.target.value });
  };

  const handleRadioChange = (event) => {
    setHardshipDetails({ ...hardshipDetails, ['isSellProperty']: event.target.value });
  };

  const handleStepperLabel = (index) =>  {
    if (hardshipDetails.hardshipS3Path) {
      setActiveStep(index)
      scrollTop()
      if (index == 1) {
        let newObj = [...lmaSupportDocuments]  
        newObj[0]['status'] = true
        const docs = newObj.map((cat, index) => ({ ...cat, 'subCategory': cat.subCategory.map((subcat, ind) => ({ ...subcat, 'checked' : ((subcat.supportDocCode == 'PID') || (subcat.supportDocCode == 'UtilityBill')) ? true : lmaSupportDocuments[index]['subCategory'][ind]['checked'] })) }))
        setLmaSupportDocuments(docs)
      }
    }
  }

  const submitBeforeValidateDocs = async () => {
    const formData = new FormData();
    formData.append('lmaApplicationId', hardshipDetails.lmaApplicationId);
    formData.append('dateHardshipStarted', hardshipDetails.hardshipDate ? dateFormat(hardshipDetails.hardshipDate) : null);
    formData.append('hardshipDuration', hardshipDetails.hardshipDuration);
    formData.append('hardshipSummary',  hardshipDetails.hardshipSummary == null ? '' : hardshipDetails.hardshipSummary);
    formData.append('isSellProperty', (hardshipDetails.isSellProperty == "Yes") ? true : false);
    formData.append('retalorEmailId',  encrypt(hardshipDetails.retalorEmailId));
    formData.append('retalorName', hardshipDetails.retalorName);
    formData.append('retalorPhone',  encrypt(hardshipDetails.retalorPhone));
    formData.append('lmaFile', null);
    formData.append('listingFile', null);
    formData.append('purchaseFile', null);
    formData.append('documentType', "");
    formData.append('privateLabelUrl', Cookies.get("privateLabelUrl"));
    formData.append('browser', Cookies.get("browser"));
    formData.append('appSource', getAppSource());
    formData.append('userType', getUserType());
    formData.append('ipAddress', Cookies.get('publicIp'));
    formData.append('accountNumber', props.accountNumber);
    formData.append('userName', "");
    const res = await submitLmaDetails(formData);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      setValidateLma(true)
    } 
  }
 
  const validateSupportedDoc = () => {
     const filterDocs = lmaSupportDocuments.map((category) => ({
         'documentCategory' : category.documentCategory,
         'subCategory': category.subCategory.filter((subCat) => (subCat.checked && (subCat.uploadedDocs[0].accountNumber == null))) 
     }))

    const subCategorys = filterDocs.filter((cat) => (cat.subCategory.length > 0))
    setDocValidations(subCategorys)
    if (subCategorys.length > 0) {
      submitBeforeValidateDocs()
    } else {
      submitBeforePreview()
    }
  }

  const scrollToPropertyToSell = () => {
    setTimeout(() => {
      const element = document.getElementById("propertyToSell");
      element.scrollIntoView({behavior: "smooth"});
    }, 1000);
  }

  const checkHardshipValidation = () => {
    scrollTop()
    setHardshipSummaryErr(false)
    setHardshipDateErr(false)
    if (!hardshipDetails.hardshipSummary) {
      setHardshipSummaryErr(true)
    } 
    if (!hardshipDetails.hardshipDate) {
      setHardshipDateErr(true)
    }
  }

  const routeToPreview = () => {
    setRealtorInfoErr(false)
    setListingDocReqErr(false)
    setRealtorNameErr(false)
    if (hardshipDetails.isSellProperty == "Yes") {
      if (!hardshipDetails.listingDocumentS3Path) {
        setSellPropertyAcc(true)
        setListingDocReqErr(true)
        scrollToPropertyToSell()
      } 
      if ((!hardshipDetails.retalorPhone) && (!hardshipDetails.retalorEmailId)) {
        setSellPropertyAcc(true)
        setRealtorInfoErr(true)
        scrollToPropertyToSell()
      } 
      if (!hardshipDetails.retalorName) {
        setSellPropertyAcc(true)
        setRealtorNameErr(true)
        scrollToPropertyToSell()
      }
      if (hardshipDetails.listingDocumentS3Path && hardshipDetails.retalorName && ((hardshipDetails.retalorPhone && !mobileValidationErrorMsg) || (hardshipDetails.retalorEmailId && !validationErrMsg))) {
        setSellPropertyAcc(false)
        setDocValidations([])
        setValidateLma(false)
        validateSupportedDoc()
      }
   } else {
     setSellPropertyAcc(false)
     setDocValidations([])
     setValidateLma(false)
     validateSupportedDoc()
   }
  }

  const getRealtorNameErrStatus = () => {
    if (realtorNameInfoErr && !hardshipDetails.retalorName) {
      return true
    } else {
      return false
    }
  }

  const submitBeforePreview = async (files, type) => {
    setLoader(true)
    const formData = new FormData();
    formData.append('lmaApplicationId', hardshipDetails.lmaApplicationId);
    formData.append('dateHardshipStarted', hardshipDetails.hardshipDate ? dateFormat(hardshipDetails.hardshipDate) : null);
    formData.append('hardshipDuration', hardshipDetails.hardshipDuration);
    formData.append('hardshipSummary',  hardshipDetails.hardshipSummary == null ? '' : hardshipDetails.hardshipSummary);
    formData.append('isSellProperty', (hardshipDetails.isSellProperty == "Yes") ? true : false);
    formData.append('retalorEmailId',  encrypt(hardshipDetails.retalorEmailId));
    formData.append('retalorName', hardshipDetails.retalorName);
    formData.append('retalorPhone',  encrypt(hardshipDetails.retalorPhone));
    formData.append('lmaFile', type == "LMA" ? files : null);
    formData.append('listingFile', type == "Sale" ? files : null);
    formData.append('purchaseFile', type == "Purchase" ? files : null);
    formData.append('documentType', files ? type : "");
    formData.append('privateLabelUrl', Cookies.get("privateLabelUrl"));
    formData.append('browser', Cookies.get("browser"));
    formData.append('appSource', getAppSource());
    formData.append('userType', getUserType());
    formData.append('ipAddress', Cookies.get('publicIp'));
    formData.append('accountNumber', props.accountNumber);
    formData.append('userName', "");
    const res = await submitLmaDetails(formData);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      setLoader(false)
      history.push('/LmaPreview')
    } else {
      setLoader(false)
      setErrorMessage(res?.responseData?.lstResponseStatus[0]?.StatusDesc)
    } 
  }

  const handleFile = (event, type) => {
    event.persist();
    if (event.target.files[0].size > LMA_FILE_SIZE_LIMIT) {
      setFilesName(event.target.files[0].name)
      setAlertStatus(true)
    } else {
      submitLmaDetail(event.target.files[0], type, false)
    }
  }

  const handleInputFile = (e) => {
    e.target.value = null;
  }

  if (loading) {
    return (
      <Box className={classes.loadingRoot}>
        <CircularProgress />
      </Box>
    )
  }
  
  const getRequiredDocStatus = () => {
    const filterDocs = lmaSupportDocuments.map((category) => ({
        'documentCategory' : category.documentCategory,
        'subCategory': category.subCategory.filter((subCat) => (subCat.checked && (subCat.uploadedDocs[0].accountNumber == null))) 
    }))

   const subCategorys = filterDocs.filter((cat) => (cat.subCategory.length > 0))
   const findLossMitigationDoc = subCategorys?.filter((doc) => doc?.documentCategory.includes('Loss Mitigation Documents'))[0]?.subCategory.length
   const findIncomeSourceDoc = subCategorys?.filter((doc) => doc?.documentCategory.includes('Income Source Documents'))[0]?.subCategory.length
   const findMiscellaneousDoc = subCategorys?.filter((doc) => doc?.documentCategory.includes('Miscellaneous Documents'))[0]?.subCategory?.length

   if ((findLossMitigationDoc == undefined) && (findIncomeSourceDoc == undefined) && (findMiscellaneousDoc == undefined)) {
      return true
   } else {
      return false
   }
 }

  const getStepperStatus = () => {
    if (hardshipDetails.isSellProperty == "Yes") {
      if ((hardshipDetails.listingDocumentS3Path && hardshipDetails.retalorName && ((hardshipDetails.retalorPhone && !mobileValidationErrorMsg) || (hardshipDetails.retalorEmailId && !validationErrMsg)) && getRequiredDocStatus())) {
         return true
      } else {
          return false
      }
    } else if (getRequiredDocStatus()) {
      return true
    }  else {
      return false
    }
  }

  const CustomStepIcon = (props) => {
    const { icon } = props;
    let displayedIcon = Pending3;

    if(activeStep == 0) {
      if(icon===1){
        displayedIcon = !getProceedBtnStatus() ? Completed : Pending3;
      }
      else if(icon===2) {
        displayedIcon=  getStepperStatus() ? Completed : Pending3;
      }
    }
    else if(activeStep == 1) {
      if(icon===1) {
        displayedIcon = !getProceedBtnStatus() ? Completed : Pending3;
      }
      else if(icon===2) {
        displayedIcon = getStepperStatus() ? Completed : Pending3;
      }
    }
    
    return (
      <Box>      
        <img src={displayedIcon}/>
      </Box>
    );
  };

  const setStatusValue = (index, status) => {
    let newObj = [...lmaSupportDocuments]  
    newObj[index]['status'] = !status
    setLmaSupportDocuments(newObj)
    setCategoryIndex(index)
  }

  const handleClose = () => {
    setDeletePopup(false)
  }

  const handleOk = () => {
    setDeletePopup(false)
    deleteDoc('LMA')
  }

  const handleLMAFileDelete = () => {
    setDeletePopup(true)
  }

  const getProceedBtnStatus = () => {
    if ((loanInfoData.loanTypeName?.toLowerCase() == 'conventional')) {
     if ((!hardshipDetails.hardshipDate) || (!hardshipDetails.hardshipSummary) || (!hardshipDetails.hardshipS3Path)) {
      return true
     } else {
      return false
     }
    } else {
      if (!hardshipDetails.hardshipS3Path) {
        return true
       } else {
        return false
       }
    } 
  }

  const getNextBtnStatus = () => {
    if ((loanInfoData.loanTypeName?.toLowerCase() == 'conventional')) {
     if ((!hardshipDetails.hardshipDate) || (!hardshipDetails.hardshipS3Path)) {
      return true
     } else {
      return false
     }
    } else {
      if (!hardshipDetails.hardshipS3Path) {
        return true
       } else {
        return false
       }
    } 
  }

  const handleRealtorInfoChange = (prop) => (event) => {
    if (prop === 'email') {
        if (validateEmail(event.target.value?.trim())) {
          setValidationErrorMsg('')
          setHardshipDetails({ ...hardshipDetails, [event.target.name]: event.target.value });
        } else {
          setValidationErrorMsg('Please enter a valid email address.')
        }
      } else if (prop === 'phone') {
        if (checkDigitOnly(event.target.value?.trim())) {
          setMobileValidationErrorMsg('')
          setHardshipDetails({ ...hardshipDetails, [event.target.name]: event.target.value });
        } else {
          setMobileValidationErrorMsg('Please enter a valid phone number.')
        }
      }
      setHardshipDetails({ ...hardshipDetails, [event.target.name]: event.target.value });
  };

  const validateEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(email) || (email == '')) {
      return true
    } else {
      return false
    }
  }

  const handleAlertClose = () => {
    setAlertStatus(false)
  }

  const handleGotIt = () => {

    setValidateLma(false)
    const findLossMitigationDoc = docValidations?.filter((doc) => doc?.documentCategory.includes('Loss Mitigation Documents'))[0]?.subCategory.length
    const findIncomeSourceDoc = docValidations?.filter((doc) => doc?.documentCategory.includes('Income Source Documents'))[0]?.subCategory.length
    const findMiscellaneousDoc = docValidations?.filter((doc) => doc?.documentCategory.includes('Miscellaneous Documents'))[0]?.subCategory?.length

    if (findLossMitigationDoc !== undefined) {
      let newObj = [...lmaSupportDocuments]  
      newObj[0]['status'] = true
      setLmaSupportDocuments(newObj) 
    }

    if (findIncomeSourceDoc !== undefined) {
      let newObj = [...lmaSupportDocuments]  
      newObj[1]['status'] = true
      setLmaSupportDocuments(newObj) 
    }

    if (findMiscellaneousDoc !== undefined) {
      let newObj = [...lmaSupportDocuments]  
      newObj[2]['status'] = true
      setLmaSupportDocuments(newObj) 
    }
    
    scrollToTop()
    
  }

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 1000)
  }

  const getRealtorErrStatus = () => {
    if (realtorInfoErr && !hardshipDetails.retalorEmailId && !hardshipDetails.retalorPhone) {
      return true
    } else {
      return false
    }
  }

  const getLmaUploadFile = () => {
    if ((loanInfoData.loanTypeName?.toLowerCase() !== 'conventional') && !hardshipDetails.hardshipS3Path) {
       return true
    } else if ((loanInfoData.loanTypeName?.toLowerCase() == 'conventional') && hardshipDetails.hardshipDate && !hardshipDetails.hardshipS3Path) {
      return true
    }
  }

  const handleNextBtn = ()  => {
    if ((loanInfoData.loanTypeName?.toLowerCase() == 'conventional') && !hardshipDetails.hardshipSummary) {
      scrollTop()
      setHardshipSummaryErr(true)
    } else {
      setCategoryIndex(0),
      submitLmaDetail(null, null, true)
    }
  }
 
  return (
    <CssBaseline>
      <>
       <Box container="true" maxWidth='xl' className={classes.root}>      
        <Box className={classes.container}>
          <CustomBreadcrum backPage="Payments" backPageLink="/PaymentOption" activePage="Financial Hardship" />
          <h1 className={classes.pageHeading} color="textPrimary" component='h4'>Loss Mitigation Application</h1>
          <Box className={classes.infoStrip}>
            {error ? (<Box><Typography className={classes.errorText}>{error}</Typography></Box>) : null}
             <Grid container spacing={1} justifyContent="space-around" columns={{ xs: 12, sm: 12, md: 12 }} >
                <Grid item xs={12} sm={12} md={8} >
                  {activeStep == 0 && <p className={classes.heading}>Hardship Details & Upload Form</p>}
                  {activeStep == 1 && <p className={classes.heading}>Upload Supporting Documents</p>}
                  {activeStep == 2 && <p className={classes.heading}>Planning to Sell Property</p>}
                </Grid>
            
                <Grid item xs={12} sm={12} md={4} >
                  <Button size="large" fullWidth
                    variant='outlined' className={classes.play} onClick={() => setHowItWorksPopupStatus(true)}>
                      <span style={{ paddingRight: '6px', marginTop: '4px' }}><img src={playIcon} /></span>See how it works
                  </Button>
                </Grid>
            </Grid> 
    
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step, index) => (
                <Step key={index}>
                  <StepLabel StepIconComponent={(props)=>CustomStepIcon(props, activeStep)}>
                    <p className={((index == 1) && !hardshipDetails.hardshipS3Path) ? classes.disableStepperLabel : classes.stepperLabel} onClick={() => handleStepperLabel(index)}>{step.label}</p>
                  </StepLabel>
                  <StepContent>
                   {(index == 0) && 
                    <Box className={`${'lmaAccordian'}`}>
                   
                        <Box className={classes.hardshipContainer}>
                          <p className={classes.procedureToFill}>Hardship Summary {(loanInfoData.loanTypeName?.toLowerCase() == 'conventional') && <span style={{color: 'red'}}>*</span>}</p>   
                          <p className={classes.readInst}>Provide a detailed exact reason that prevents you from paying your mortgage loan(s) and information about your intentions to either keep or transition out of your property.</p>   

                          <Box className={classes.textareaSection}>
                            <TextareaAutosize
                              style={{ height: '96px', width: '100%' }}
                              color="primary"
                              variant="outlined"
                              type="text"
                              name="hardshipSummary"
                              maxLength="1000"
                              onChange={(event) => handleChange(event) }
                              value={ hardshipDetails.hardshipSummary}
                              placeholder='Hardship Summary'
                              className={`${classes.textArea}`}
                            >
                              </TextareaAutosize>
                              <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/1000</Typography>
                              {(hardshipSummaryErr && !hardshipDetails.hardshipSummary) && <p className={classes.supportDocError}>Please provide hardship summary.</p>}

                          </Box>   
     
                              <p className={classes.procedureToFill}>Date since hardship situation began is { (loanInfoData.loanTypeName?.toLowerCase() == 'conventional') && <span style={{color: 'red'}}>*</span>}</p>   
                              <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
                              <Grid container className={classes.datePicker}>
                                 <KeyboardDatePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    format="MM/DD/YYYY"
                                    margin="normal"
                                    label="Date"
                                    defaultValue={null}
                                    placeholder="MM/DD/YYYY"
                                    value={hardshipDetails.hardshipDate}
                                    onChange={handleDateChange}
                                    maxDate={new Date()}
                                    KeyboardButtonProps={{
                                        onFocus: e => {
                                        setIsOpen(true);
                                        }
                                    }}
                                    PopoverProps={{
                                        disableRestoreFocus: true,
                                        onClose: () => {
                                        setIsOpen(false);
                                        }
                                    }}
                                    InputProps={{
                                        onFocus: () => {
                                        setIsOpen(true);
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    open={isOpen}
                                    />
                                </Grid>
                                </MuiPickersUtilsProvider>
                                {(hardshipDateErr && !hardshipDetails.hardshipDate) && <p className={classes.supportDocError}>Please provide hardship date.</p>}

                                <Box className={classes.marginFixed}>
                                    <p className={classes.procedureToFill}>I believe that my situation is:</p>

                                    <FormGroup  className={classes.propertyRadio}>
                                      <FormControlLabel
                                        control={<Checkbox
                                          id="1"
                                          checked={hardshipDetails.hardshipDuration == "short-term" ? true : false}
                                          onChange={(event) => handleHardshipTerm("short-term", event)}
                                          disabled={((hardshipDetails.hardshipDuration == "medium-term") || (hardshipDetails.hardshipDuration == "long-term")) ? true : false}
                                          name="short-term"
                                          value="short-term" />}
                                          label="Short-term (under 6 months) "
                                          classes={{
                                            label: classes.activeLabel
                                          }}
                                      />
                                      <FormControlLabel
                                        control={<Checkbox
                                          id="2"
                                          checked={hardshipDetails.hardshipDuration == "medium-term" ? true : false}
                                          onChange={(event) => handleHardshipTerm("medium-term", event)}
                                          name="medium-term"
                                          disabled={((hardshipDetails.hardshipDuration == "short-term") || (hardshipDetails.hardshipDuration == "long-term")) ? true : false}
                                          value="medium-term" />}
                                          label="Medium-term (6-12 months) "
                                          classes={{
                                            label: classes.activeLabel
                                          }}
                                      />
                                      <FormControlLabel
                                        control={<Checkbox
                                          id="3"
                                          checked={hardshipDetails.hardshipDuration == "long-term" ? true : false}
                                          onChange={(event) => handleHardshipTerm("long-term", event)}
                                          disabled={((hardshipDetails.hardshipDuration == "medium-term") || (hardshipDetails.hardshipDuration == "short-term")) ? true : false}
                                          name="long-term"
                                          value="long-term" />}
                                          label="Long-term or permanent (greater than 12 months)"
                                          classes={{
                                            label: classes.activeLabel
                                          }}
                                        />
                                      </FormGroup>
                                  </Box>
                                  
                                  <Box >
                                    <p className={classes.procedureToFill}>Upload Filled Loss Mitigation Form <span style={{color: 'red'}}>*</span></p>   
                                    <p className={classes.line}></p>
                                    <p className={classes.readInst}>Please upload the ‘Loss Mitigation Form’ after filling up the necessary details.</p>  
                                  </Box>

                                  <Box className={classes.fileUpload}>
                                  
                                    <p className={classes.attachFile}>
                                      Attach a file <span style={{color: 'red'}}>*</span>
                                    </p>
                                    <Box>
                                   { getLmaUploadFile() &&
                                    <>
                                     <input
                                      accept=".pdf, image/png, image/jpg, image/jpeg"
                                      type="file"
                                      name='selectedFile'
                                      style={{display: 'none'}}
                                      id="upload-button"
                                      onClick={(e) => handleInputFile(e)}
                                      onChange={(e) => handleFile(e, 'LMA')}
                                        />
                                      <Button component="label" variant="contained" className={classes.chooseFileButton} >
                                        CHOOSE FILE
                                        <VisuallyHiddenInput type="file" accept=".png, .jpg, .pdf, .jpeg" onClick={(e) => handleInputFile(e)}
                                        onChange={(e) => handleFile(e, "LMA")} />
                                      </Button>
                                      </>
                                      } 
                                      { ((loanInfoData.loanTypeName?.toLowerCase() == 'conventional') && !hardshipDetails.hardshipDate && !hardshipDetails.hardshipS3Path) &&
                                      <Button component="label" variant="contained" className={classes.chooseFileButton} onClick={checkHardshipValidation}>
                                        CHOOSE FILE
                                      </Button> }

                                      { (hardshipDetails.hardshipS3Path) &&
                                          <Box className={classes.uploadedImageContainer}>
                                            <Box className={classes.uploadedImage}>
                                                <img className={classes.checkImg} src={pdf} alt='pdf' /> 
                                                <Typography className={classes.imageText} onClick={() => downloadDocument('LMA', hardshipDetails.hardshipLocalFileName)}>{shortText(hardshipDetails.hardshipLocalFileName)} </Typography>
                                                <LightTooltip
                                                  arrow  placement="top"
                                                    title="Delete"
                                                  >
                                                  <DeleteIcon color="action" onClick={() => handleLMAFileDelete('LMA')} style={{cursor: 'pointer', color: '#4D4D4D'}}></DeleteIcon>
                                                </LightTooltip>
                                            </Box>
                                          </Box>
                                        }
                                    </Box>

                                    { (hardshipDetails.hardshipS3Path == null) &&
                                    <Box className={classes.chooseFile} >
                                      (Max allowed size: 5 MB)
                                    </Box> }
                                  </Box>
                         
                                  <Box className={classes.footerSection}>
                                      <Grid container style={{ marginTop: '12px' }}>
                                          <Grid item xs={10} md={9} >
                                              
                                          </Grid>
                                          <Grid item xs={10} md={3} className={classes.pl35}>
                                              <Box className={classes.saveBtnBox}>
                                                  <Button
                                                  className={classes.nextBtn}
                                                  variant="contained"
                                                  disabled={getNextBtnStatus()}
                                                  onClick={() => handleNextBtn()}
                                                  color="primary">NEXT
                                                  </Button> 
                                              </Box>
                                          </Grid>
                                      </Grid>
                                  </Box>
                                </Box>
                        
                      </Box> }

                      {(index == 1) && 
                      <Box className={`${'lmaAccordian'}`}>
                     
                        <Box className={classes.hardshipContainer}>
                          <Box className={classes.infoTopBox}>
                            <ul>                  
                              <Typography className={classes.info}> <li>Please upload the required documents for the fields you choose.</li> </Typography>
                              <Typography className={classes.info}><li>Supported file types are .pdf, .jpeg, .jpg, and .png.</li> </Typography>   
                              <Typography className={classes.info}><li>A maximum of 5 attachments, each up to 5MB in size, can be uploaded.</li></Typography>                            
                              <Typography className={classes.info}><li>If you have multiple documents, we recommend you to compress/merge them into a single file before uploading. </li></Typography>                
                            </ul>                                               
                          </Box>
                          <p className={classes.selectApply}>Select all that apply</p>   
                          
                          {lmaSupportDocuments.map((documentCategory, categoryIndex) => (
                         <Accordion expanded={documentCategory?.status == true} onChange={() => setStatusValue(categoryIndex, documentCategory?.status)}>

                        <AccordionSummary
                        expandIcon={ <ExpandMoreIcon className={classes.expand_icon}/>}
                        className={classes.transactionText}
                        >
                          <p className={classes.accordianHeading}>{documentCategory.documentCategory}</p> 
                        </AccordionSummary>

                        <AccordionDetails> 
                        { documentCategory.subCategory.map((subCategory, subCategoryIndex) => (
                          <Box className={classes.uploadDocsSection}>
                           { <FormGroup  className={classes.propertyRadio}>
                                <FormControlLabel
                                  control={<Checkbox
                                    checked={subCategory.checked}
                                    onChange={(event) => handleUploadDocCheckbox(event, categoryIndex, subCategoryIndex)}
                                    disabled={((subCategory.supportDocCode == 'PID') || (subCategory.supportDocCode == 'UtilityBill')) ? true : false }
                                    name="checkbox"
                                    />}
                                    label={ ((subCategory.supportDocCode == 'PID') || (subCategory.supportDocCode == 'UtilityBill')) ? 
                                      <span>{subCategory.supportDocName} <span style={{color: 'red'}}>*</span></span> : subCategory.supportDocName}
                                    classes={{
                                      label: classes.checkboxLabel
                                  }}
                                />
                            </FormGroup> } 
                            <Box className={classes.fileUploadSection}>
                            {(subCategory.checked && (subCategory?.uploadedDocs[0].accountNumber == null)) && <p className={classes.supportDocError}>Required document has not been uploaded. Please upload this document to proceed.</p>}
                            <p className={classes.supportDocDesc} dangerouslySetInnerHTML={{ __html: subCategory.supportDocDesc }}></p>   
                           
                            { (subCategory.supportDocName.toLowerCase() == "other income") &&
                            <Box className={classes.textareaSection}>
                              <TextField
                                  color='primary'
                                  label="Specify Other Income"
                                  variant="outlined"
                                  type="text"
                                  value={hardshipDetails.comments}
                                  name="comments"
                                  onChange={(event) => handleChange(event) }
                                  className={classes.specifyOtherIncome}
                                  disabled={(subCategory?.uploadedDocs[0].accountNumber != null) ? true : false}
                                  inputProps={{
                                    maxLength: 100,
                                    classes: { root: classes.textField }
                                  }}
                                  InputLabelProps={{
                                      classes: { root: classes.textField },
                                      formlabelclasses: {
                                        asterisk: classes.labelAsterisk
                                      }
                                  }}
                              /> 
                              </Box>
                            }
                            <>
                              <input
                                accept=".pdf, image/png, image/jpg, image/jpeg"
                                type="file"
                                name='selectedFile'
                                style={{display: 'none'}}
                                id="upload-button"
                                onClick={(e) => handleInputFile(e)}
                                onChange={(e) => uploadFile(e, subCategory)}
                                />
                              <Button component="label" variant="contained" className={(subCategory?.uploadedDocs.length == 5) ? classes.fileBtnDisable : classes.fileButton} disabled={((subCategory?.uploadedDocs.length == 5) || ((subCategory.supportDocCode == 'OtherInc') && !hardshipDetails.comments))  ? true : false}>
                                CHOOSE FILE(S)
                                <VisuallyHiddenInput type="file" accept=".png, .jpg, .pdf, .jpeg" onClick={(e) => handleInputFile(e)}
                                onChange={(e) => uploadFile(e, subCategory)} />
                              </Button>
                              </>
                              
                              <Grid container >

                              { (subCategory?.uploadedDocs[0].accountNumber != null) && subCategory?.uploadedDocs.map((key, docIndex) => {  

                              return (
                                <Grid item xs={12} sm={12} md={4}>
                                  <Box className={classes.uploadedImagesBox}>
                                    <Box className={classes.uploadedImg}>
                                       { !key.localFileName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> }
                                        <Typography className={classes.imageText} onClick={() => downloadSupportedDocs(key.localFileName, key?.uploadDocumentId)}>{shortText(key.localFileName)} </Typography>
                                        <LightTooltip
                                          arrow  placement="top"
                                            title="Delete"
                                          >
                                          <DeleteIcon color="action" onClick={() => deleteSupportedDocs(key?.uploadDocumentId, categoryIndex, subCategoryIndex, docIndex)} style={{cursor: 'pointer', color: '#4D4D4D'}}></DeleteIcon>
                                        </LightTooltip>
                                     </Box>
                                   </Box>
                                  </Grid>
                                  )})}
                                </Grid>   
                               </Box>
                             </Box> ))}

                           </AccordionDetails>
                          </Accordion>))}
                              
                          {/* Planning to sell property accordian     */}

                        <Accordion expanded={sellPropertAcc} onChange={() => setSellPropertyAcc(!sellPropertAcc)}>
                        <AccordionSummary
                        expandIcon={ <ExpandMoreIcon className={classes.expand_icon}/>}
                        className={classes.transactionText}
                        >
                          <Box display="flex" id="propertyToSell">
                            <Typography className={classes.procedureToFill}>Planning to Sell Property?</Typography>
                            <Typography>
                              <LightTooltip arrow placement="bottom" title={<div dangerouslySetInnerHTML={{ __html: tooltipMsg}}/>}>
                                <InfoIcon style={{ fill: "#535D6D", marginLeft: "5px" }} />
                              </LightTooltip>
                            </Typography>
                          </Box>
                        </AccordionSummary>

                        <AccordionDetails> 
                        <Box className={classes.hardshipContainer} >
                         
                            <p className={classes.decision}>If you aren’t sure with your decision, proceed with your selection as ‘No’.</p>
                            <div className={classes.radioBtn}>
                              <RadioGroup row aria-label="sell_property" name="sell_property" value={hardshipDetails.isSellProperty}
                                onChange={handleRadioChange}>
                                <FormControlLabel value="Yes" 
                                  control={<Radio />} label="Yes" />
                                <FormControlLabel value="No"
                                  control={<Radio />} label="No" />
                              </RadioGroup>
                            </div>  
                             { (hardshipDetails.isSellProperty == "Yes") &&
                             <>
                              <Box className={classes.listingSection}>
                                <p className={classes.procedureToFill}>Listing Agreement <span style={{color: 'red'}}>*</span></p>   
                                
                                 <p className={classes.signedAgreement}>Please upload a copy of the signed listing agreement with your real estate agent. This document should outline the terms and conditions under which your property is being marketed for sale.</p>
       
                                {(listingDocReq && !hardshipDetails.listingDocumentS3Path) && <p className={classes.supportDocError}>Required document has not been uploaded. Please upload this document to proceed.</p>}

                              { (!hardshipDetails.listingDocumentS3Path) &&
                              <>
                                <input
                                  accept=".pdf, image/png, image/jpg, image/jpeg"
                                  type="file"
                                  name='selectedFile'
                                  style={{display: 'none'}}
                                  id="upload-button"
                                  onClick={(e) => handleInputFile(e)}
                                  onChange={(e) => handleFile(e, 'Sale')}
                                  />
                                <Button component="label" variant="contained" className={classes.fileButton} >
                                  CHOOSE FILE
                                  <VisuallyHiddenInput type="file" accept=".png, .jpg, .pdf, .jpeg" onClick={(e) => {setCategoryIndex(null);handleInputFile(e)}}
                                  onChange={(e) => handleFile(e, 'Sale')} />
                                </Button>
                                </>}
                                { (hardshipDetails.listingDocumentS3Path) && 
                                <Grid container>
                                 { (hardshipDetails.listingLocalName !== null) &&   
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className={classes.uploadedImagesBox}>
                                      <Box className={classes.uploadedImg}>
                                      { !hardshipDetails?.listingLocalName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> }
                                          <Typography className={classes.fileText} onClick={() => downloadDocument('Sale', hardshipDetails?.listingLocalName)}>{shortText(hardshipDetails?.listingLocalName)} </Typography>
                                          <LightTooltip
                                            arrow  placement="top"
                                              title="Delete"
                                            >
                                            <DeleteIcon color="action" onClick={() => deleteDoc('Sale')} style={{cursor: 'pointer', color: '#4D4D4D'}}></DeleteIcon>
                                          </LightTooltip>
                                       </Box>
                                     </Box>
                                    </Grid>
                                    }
                                  </Grid>  } 
                                 </Box>
  
                                 <Box className={classes.realtorSection}>
                                 <p className={classes.procedureToFill}>Realtor Information <span style={{color: 'red'}}>*</span></p>   
                                
                                 <p className={classes.signedAgreement}>Provide the contact details of your real estate agent, including their name, phone number, and email address. This information will help us coordinate and verify details as part of your loss mitigation process.</p>
     
                                 <Grid container>
                                  <Grid item  md={6} xs={12} lg={6}>
                                  <Box className={classes.inputContainer}>
                                      <TextField
                                          color='primary'
                                          label={<span>Name<sup style={{color: 'red'}}>*</sup></span>}
                                          variant="outlined"
                                          type="text"
                                          value={hardshipDetails.retalorName}
                                          name="retalorName"
                                          onChange={(event) => handleChange(event) }
                                          fullWidth
                                          className={`${classes.inputStyle} ${classes.pl20}`}
                                          inputProps={{
                                            maxLength: 50,
                                            classes: { root: classes.textField },
                                              
                                          }}
                                      />
                                      {getRealtorNameErrStatus() && <p className={classes.supportDocError}>Please provide name under Realtor Information.</p>}
                                    </Box> 
                                   </Grid>
                                   <Grid item  md={6} xs={12} lg={6}>
                                  <Box className={classes.inputContainer}>
                                      <TextField
                                          helperText={mobileValidationErrorMsg}
                                          error={mobileValidationErrorMsg}
                                          value={hardshipDetails?.retalorPhone}
                                          color='primary'
                                          label="Phone Number"
                                          name="retalorPhone"
                                          onChange={handleRealtorInfoChange('phone')}
                                          variant="outlined"
                                          type="text"
                                          fullWidth
                                          className={`${classes.inputStyle} ${classes.pl20}`}
                                        
                                          inputProps={{
                                            maxLength: 10,
                                            classes: { root: classes.textField },
                                              
                                          }}
                                         
                                      />
                                    </Box>  
                                   </Grid>
                                  </Grid>
                                  <Grid container>
                                  <Grid item  md={6} xs={12} lg={6}>
                                  <Box className={classes.inputContainer}>
                                      <TextField
                                          helperText={validationErrMsg}
                                          error={validationErrMsg}
                                          color='primary'
                                          label="Email"
                                          variant="outlined"
                                          type="text"
                                          value={hardshipDetails?.retalorEmailId}
                                          name="retalorEmailId"
                                          onChange={handleRealtorInfoChange('email')}
                                          fullWidth
                                          className={`${classes.inputStyle} ${classes.pl20}`}
                                          
                                          InputProps={{
                                              classes: { root: classes.textField },
                                              
                                          }}
                                        
                                      />
                                    </Box>  
                                   </Grid>
                                  </Grid>
                                  {getRealtorErrStatus() && <p className={classes.supportDocError}>Please provide either Phone Number or Email under Realtor Information.</p>}
                                 </Box>
  
                                 <Box>
                                <p className={classes.procedureToFill}>Purchase Offer (Optional)</p>   
                                 <p className={classes.signedAgreement}>If you have received any purchase offers for your property, please upload them here. Although optional, providing these offers can help expedite the review and decision-making process.</p>
                                 { (!hardshipDetails.purchaseOfferS3S3Path ) &&
                                <>
                                  <input
                                  accept=".pdf, image/png, image/jpg, image/jpeg"
                                  type="file"
                                  name='selectedFile'
                                  style={{display: 'none'}}
                                  id="upload-button"
                                  onClick={(e) => handleInputFile(e)}
                                  onChange={(e) => handleFile(e, 'Purchase')}
                                    />
                                  <Button component="label" variant="contained" className={classes.fileButton} >
                                    CHOOSE FILE
                                    <VisuallyHiddenInput type="file" accept=".png, .jpg, .pdf, .jpeg" onClick={(e) => {setCategoryIndex(null);handleInputFile(e)}}
                                    onChange={(e) => handleFile(e, 'Purchase')} />
                                  </Button>
                                  </>}
                                  { hardshipDetails.purchaseOfferS3S3Path &&
                                <Grid container >
  
                                  <Grid item xs={12} sm={12} md={4}>
                                    <Box className={classes.uploadedImagesBox}>
                                      <Box className={classes.uploadedImg}>
                                      { !hardshipDetails?.purchaseLocalFileName.includes('pdf') ? <img className={classes.checkImg} src={image} alt='img' /> :  <img className={classes.checkImg} src={pdf} alt='pdf' /> }
                                          <Typography className={classes.fileText} onClick={() => downloadDocument('Purchase', hardshipDetails?.purchaseLocalFileName)}>{shortText(hardshipDetails?.purchaseLocalFileName)} </Typography>
                                          <LightTooltip
                                            arrow  placement="top"
                                              title="Delete"
                                            >
                                            <DeleteIcon color="action" onClick={() => deleteDoc('Purchase')} style={{cursor: 'pointer', color: '#4D4D4D'}}></DeleteIcon>
                                          </LightTooltip>
                                       </Box>
                                     </Box>
                                    </Grid>
                                    
                                  </Grid>  } 
                                 </Box>
                              </>
                            }
                           
                          </Box>
                           </AccordionDetails>
                          </Accordion>
                              
                        </Box>
                       
                    </Box> }
                  </StepContent>
                </Step>
              ))}
            </Stepper>
      
            <Box className={classes.footerSection}>
              <Grid container style={{ marginTop: '12px' }}>
                  <Grid item xs={6} md={6} className={classes.pr35}>
                      <Box className={classes.cancelBtnBox}>
                      <Button
                          className={classes.cancelBtn}
                          variant="outlined"
                          onClick={() => routeToFinancialHardship()} 
                      >BACK</Button>
                      </Box>
                  </Grid>
                  <Grid item xs={6} md={6} className={classes.pl35}>
                      <Box className={classes.saveBtnBox}>
                          <Button
                          className={classes.saveBtn}
                          variant="contained"
                          disabled={getProceedBtnStatus()}
                          onClick={() => routeToPreview()}
                          color="primary">
                          PROCEED & PREVIEW</Button> 
                      </Box>
                  </Grid>
              </Grid>
            </Box>

         </Box>
        </Box>
      </Box>
      <DeleteConfirmation 
          open={deleteStatus}
          handleClose={handleClose}
          handleOk={handleOk}
          title='Are you sure you want to delete?'
        />
       <FileSizeAlert
        open={alertStatus}
        handleAlertClose={handleAlertClose}
        file={file}
      />  
      <HowItWorks
        open={howItWorksPopupStatus}
        handleAlertClose={handleHowItWorksClose}
      /> 
       <LmaValidate 
          open={validateLma}
          handleGotIt={handleGotIt}
          docValidations={docValidations}
        />
     </> 
    </CssBaseline>
  )
}

